// extracted by mini-css-extract-plugin
export default {"container":"ManualUW_container__I35k1","icon":"ManualUW_icon__nLkmO","title":"ManualUW_title__EKJTf","body":"ManualUW_body__lpck4","links":"ManualUW_links__XI9+A"};